<ng-template #content let-modal>
	<ng-container *ngTemplateOutlet="selectedStep;"></ng-container>
	<div class="modal-footer">
		<button type="button" class="btn btn-light pull-left" (click)="closeModal()">Close</button>
		<input type="checkbox" [(ngModel)]="dontShow"> Dont show intro again.
		<button type="button" class="btn mainButton" style="margin-left: auto" (click)="changeStep()" *ngIf="step < 3">Next</button>
		<button type="button" class="btn mainButton" *ngIf="step === 3" style="margin-left: auto" (click)="changeStep(-1)">Back</button>
	</div>
</ng-template>
<ng-template #step1>
	<div class="modal-header">
		<h4 class="text-center modal-title">Welcome to CultureVR Tour Engine</h4>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>
			We are excited that you choose to give a try to our virtual tour engine that the team of CultureApp has created in order to accommodate
			visitors to know a place before traveling, to get in touch with guides for a virtual tour etc etc.
		</p>
		<p class="text-center">
			<img src="/assets/images/logo.png" />
		</p>
		<p class="text-center">Before starting using the Tour Engine first let us walk you through some basic stuff.</p>
	</div>
</ng-template>
<ng-template #step2>
	<div class="modal-header">
		<h4 class="text-center modal-title">The guide panel</h4>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>
			On the left of the screen there is a ribbon with all the available features a guide can use to make the Tour more appealing to the users.
		</p>
		<p>
			The ribbon is consisted from the follow buttons. Next to each button there is an explanation of its use.
		</p>
		<div style="padding: 0 10px">
			<ul class="list" style="">
				<li>
					<fa-icon [icon]="['fas','users']"></fa-icon>
					<span>Toggles the user section on the right of the screen. From there you can view your camera and the cameras of the tour
						  participants</span>
				</li>
				<li>
					<fa-icon [icon]="['far','comment-dots']"></fa-icon>
					<span>Toggle the chat section between the participants. There will be a notification banner when a new message arrives.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','folder']"></fa-icon>
					<span>In this section you have access to your personal uploaded files. These files is your own and i can be used only by
						  you when you are guide the visitors through the Tour.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','landmark']"></fa-icon>
					<span>Toggles the Culture App monument database. Culture App database is accurate and very detailed. The information provided
					is free of charge and maintained constantly by experts.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','globe-europe']"></fa-icon>
					<span>Navigate to the first section the map where you can locate geographically all the CultureApp database.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','info-circle']"></fa-icon>
					<span>Toggles the information context. Here there are meta data (last share image, last shared file etc) that are communicated
						  ony to you in order to have a better control of the tour. </span>
				</li>
			</ul>
		</div>
	</div>
</ng-template>

<ng-template #step3>
	<div class="modal-header">
		<h4 class="text-center modal-title">The call controls</h4>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>
			On the bottom section of the screen there are all the selections for controlling the call between you and the visitors.
		</p>
		<p>
			The buttons that controlling the call are:
		</p>
		<div style="padding: 0 10px">
			<ul class="list" style="">
				<li>
					<fa-icon [icon]="['fas','share-square']"></fa-icon>
					<span>This is the <b>most important</b> button. It gives you the ability to share the current screen that you facing
						  with the visitors. Each time it is pressed the visitors are able to see a snapshot of your information you are
						  viewing.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','microphone']"></fa-icon>
					<span>Toggle your microphone sound. You can mute or unmute yourself.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','video']"></fa-icon>
					<span>Toggle the camera. You can enable or disable the video.</span>
				</li>
				<li>
					<fa-icon [icon]="['fas','phone']"></fa-icon>
					<span>This button ends the call and terminate the meeting. Use it with caution.</span>
				</li>
			</ul>
		</div>
	</div>
</ng-template>